import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToolboxMailMergeState, ToolboxMailMergeOptions } from 'src/app/state-management';

@Component({
    selector: 'app-dnv-mailmerge',
    templateUrl: './dnv-mailmerge.component.html',
    styleUrls: ['./dnv-mailmerge.component.scss'],
    standalone: false
})
export class DnvMailmergeComponent implements OnInit, OnChanges {
  @Input() sliderOptions: Options;
  @Input() mailMergeState: ToolboxMailMergeState;
  @Input() showOptions: boolean = true;
  // @Input() resultCount: number;
  @Output() downloadEmitter = new EventEmitter<ToolboxMailMergeOptions>();
  @Output() mailLabelOptionsEmitter = new EventEmitter<any>();
  @Output() mailLabelSelectEmitter = new EventEmitter<any>();
  @Output() mailLabelDrawEmitter = new EventEmitter<any>();
  @Output() mailLabelClearEmitter = new EventEmitter<any>();
  @Output() mailBufferEmitter = new EventEmitter<number>();

  @ViewChild('modalCombineOwners') public modalCombineOwners: TemplateRef<any>;
  mailMergeForm: UntypedFormGroup;
  bufferValue = 10;
  sliderSubscribe: any;
  inputSubscribe: any
  private bufferSubject: Subject<number> = new Subject<number>();
  private bufferSubscription: Subscription;
  modal: NgbModalRef = null;

  isOccupants = false;
  isOwners = false;

  recipientsValues = [
    { name: 'Owners', id: 'owners' },
    { name: 'Occupants', id: 'occupants' }
  ];


  constructor(
    private modalService: NgbModal
  ) {
    const controls = this.recipientsValues.map(c => new UntypedFormControl(false));

    this.mailMergeForm = new UntypedFormGroup({
      selectionMethod: new UntypedFormControl(),
      selectionBuffer: new UntypedFormControl(),
      mailSliderControl: new UntypedFormControl(),
      recipients: new UntypedFormArray(controls, minSelectedCheckboxes(1)),
      combineOwners: new UntypedFormControl({ value: false, disabled: true }),
      ownerName: new UntypedFormControl({ value: false, disabled: true }),
    });

    this.bufferSubscription = this.bufferSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((value: number) => {
        this.mailBufferEmitter.emit(value);
        // this.updateResultCount();
      });

  }

  ngOnInit(): void {
    if (this.mailMergeState) {
      this.mailMergeForm.get('selectionMethod').setValue(this.mailMergeState.selectionMethod);
      this.mailMergeForm.get('selectionBuffer').setValue(this.mailMergeState.selectionBuffer);
      this.mailMergeForm.get('mailSliderControl').setValue(this.mailMergeState.selectionBuffer);
    }

  }

  ngOnChanges() {
    if (this.mailMergeState) {
      this.mailMergeForm.get('selectionMethod').setValue(this.mailMergeState.selectionMethod);
      this.mailMergeForm.get('selectionBuffer').setValue(this.mailMergeState.selectionBuffer);
      this.mailMergeForm.get('mailSliderControl').setValue(this.mailMergeState.selectionBuffer);

      // loop? TODO keep here until all params can be moved into state
      // this.updateResultCount();
    }
  }


  bufferSliderChange(event: any) {
    this.bufferSubject.next(event);
    this.mailMergeForm.get('selectionBuffer').setValue(event);
  }
  bufferChange(event: any) {
    this.bufferSubject.next(parseInt(event.target.value));
    this.mailMergeForm.get('mailSliderControl').setValue(parseInt(event.target.value));
  }

  mailLabelSelect() {
    this.mailLabelSelectEmitter.emit();
  }

  mailLabelDraw() {
    this.mailLabelDrawEmitter.emit();
  }

  mapClear() {
    this.mailLabelClearEmitter.emit();
    // this.updateResultCount();
  }


  downloadCSV(): void {
    this.downloadEmitter.emit();

    // const groupOwners = this.mailMergeForm.get('combineOwners').value;
    // const prefOwn = this.mailMergeForm.get('ownerName').value;

    // this.downloadEmitter.emit({ toOwners: this.isOwners, toOccupants: this.isOccupants, groupOwners: groupOwners, preferOwnerName: prefOwn });

  }

  // updateResultCount(): void {

  //   const groupOwners = this.mailMergeForm.get('combineOwners').value;
  //   const prefOwn = this.mailMergeForm.get('ownerName').value;

  //   this.updateResultCountEmitter.emit({ toOwners: this.isOwners, toOccupants: this.isOccupants, groupOwners: groupOwners, preferOwnerName: prefOwn });

  // }

  openModal(modal: TemplateRef<any>): void {
    this.modal = this.modalService.open(modal, { windowClass: "mailmerge-modal" });
  }

  close(): void {
    if (this.modal) {
      this.modal.close();
    }
  }

  onCheckChanged(evt: any): void {
    const recipients = this.mailMergeForm.get('recipients').value;
    if (recipients[0]) {
      this.isOwners = true;
    } else {
      this.isOwners = false;
    }

    if (recipients[1]) {
      this.isOccupants = true;
      this.mailMergeForm.get('ownerName').enable();
    } else {
      this.isOccupants = false;
      this.mailMergeForm.get('ownerName').disable();
    }

    const prefOwn = this.mailMergeForm.get('ownerName').value;
    const groupOwners = this.mailMergeForm.get('combineOwners').value;

    if (recipients[0] || prefOwn === true) {
      this.mailMergeForm.get('combineOwners').enable();
    } else {
      this.mailMergeForm.get('combineOwners').disable();
    }

    if (recipients[0] && groupOwners === true) {
      this.openModal(this.modalCombineOwners);
    }

    // this.updateResultCount();
    // ToolboxMailMergeOptions
    this.mailLabelOptionsEmitter.emit({
      isOwners: this.isOwners,
      isOccupants: this.isOccupants,
      groupOwners: groupOwners,
      prefOwn: prefOwn
    });
  }

  formControls() {
    return (this.mailMergeForm.get('recipients') as UntypedFormArray).controls;
  }

}

function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: UntypedFormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
